import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLinkClick = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: .5,
			y1: -.5,
			x2: 3.5,
			y2: -.5,
			transform: "matrix(-0.977045 0.213034 0.213034 0.977045 5.68988 8.22855)",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.39618 9.22827L3.59523 11.3424",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.79355 6.46475L2.31754 5.46937",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5,
			y1: -.5,
			x2: 3.5,
			y2: -.5,
			transform: "matrix(0.298045 -0.954552 -0.954552 -0.298045 7.88531 5.31244)",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.81049 4.64056L6.56614 1.87408",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.86163 5.40569L12.0386 3.46637",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M9.31059 16.4524L6.72128 7.74804C6.47178 6.90929 7.34377 6.17728 8.12662 6.5683L15.6243 10.3133C16.3759 10.6887 16.3576 11.7675 15.5936 12.1172L13.6098 13.0252L15.8103 15.6876C16.1217 16.0644 16.1151 16.6111 15.7946 16.9802L15.7332 17.051C15.3281 17.5176 14.6009 17.5088 14.2073 17.0325L12.2191 14.6271L11.1523 16.6362C10.7326 17.4265 9.56573 17.31 9.31059 16.4524Z" })
	]
});
export default SvgIconLinkClick;
